<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{title}}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>

        <div v-else>
          <CForm>
            <CRow>
              <CCol sm="6">
                <CInput
                  disabled
                  label="Order Number"
                  invalid-feedback="Order Number should be filled"
                  required
                  v-model="$v.confirmationPaymentForm.order_number.$model"
                  :is-valid="!$v.confirmationPaymentForm.order_number.$invalid"
                />
              </CCol>
              <CCol sm="6">
                <CInput
                  disabled
                  label="User Code"
                  invalid-feedback="User Code should be filled"
                  required
                  v-model="$v.confirmationPaymentForm.user_code.$model"
                  :is-valid="!$v.confirmationPaymentForm.order_number.$invalid"
                />
              </CCol>
              <CCol sm="6">
                <CInput
                  disabled
                  label="Payment Date"
                  invalid-feedback="Payment Date should be filled"
                  required
                  v-model="$v.confirmationPaymentForm.payment_date.$model"
                  :is-valid="!$v.confirmationPaymentForm.payment_date.$invalid"
                />
              </CCol>
              <CCol sm="6">
                <CInput
                  disabled
                  label="Account No"
                  invalid-feedback="Account No should be filled"
                  required
                  v-model="$v.confirmationPaymentForm.account_no.$model"
                  :is-valid="!$v.confirmationPaymentForm.account_no.$invalid"
                />
              </CCol>
              <CCol sm="6">
                <CInput
                  disabled
                  label="Account Name"
                  invalid-feedback="Account Name should be filled"
                  required
                  v-model="$v.confirmationPaymentForm.account_name.$model"
                  :is-valid="!$v.confirmationPaymentForm.account_name.$invalid"
                />
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton color="danger" title="Edit" size="sm" class="text-center" @click="back">
              <i class="fa fa-undo"></i> Back
            </CButton>&nbsp;
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab>
            <template slot="title">
              List Order
            </template>
            <OrderList :items="orderDetailData" :isLoading="isLoading"></OrderList>
          </CTab>
          <CTab>
            <template slot="title">
              Bukti Transfer
            </template>
            <br />
            <img width="100" :src="'https://storage.googleapis.com/isikulkas/' + confirmationPaymentForm.picture+'?r='+unixTime" />
            <br />
            <br />
            <CButton @click="preview()" size="sm" color="linkedin">
              <span>Preview Image</span>
            </CButton>
          </CTab>
          <CTab>
            <template slot="title">
              Action Payment
            </template>
            <br />
            <Loading v-if="isLoading"></Loading>
            <CCol v-else sm="3">
              <div class="form-group">
                <label for="status_order">Status Order</label>
                <model-select
                  class="form-control"
                  id="status_order"
                  :options="statusList"
                  v-model="$v.orderForm.status.$model"
                  :isError="$v.orderForm.status.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.orderForm.status.$invalid"
                  class="invalid-feedback-custom"
                >User should be filled.</div>
              </div>
              <CButton color="success" title="Detail" size="sm" @click="updateStatus">
                <i class="fa fa-edit" /> Save
              </CButton>
            </CCol>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="previewModal"
    >
      <template #header>
        <h6 class="modal-title">Preview Image</h6>
      </template>

      <CForm style="text-align:center">
        <img :src="'https://storage.googleapis.com/isikulkas/' + confirmationPaymentForm.picture+'?r='+unixTime" />
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../../templates/Loading";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import OrderList from "../../order/tabs/OrderList";

export default {
  name: "ConfirmationPaymentDetail",
  components: { GlobalTable, Loading, OrderList },
  data() {
    return {
      title: "Confirmation payment Detail",
      confirmationPaymentForm: tableInterfaces.confirmation_payment,
      orderForm: tableInterfaces.order,
      items: [],
      statusList: [],
      orderDetailData: [],
      isLoading: false,
      loadingTab: false,
      loadingStatus: false,
      isEdit: false,
      addButton: false,
      previewModal: false,
      activeTab: 0,
      unixTime: Math.floor(Math.random() * (0 - 9999999999 + 1) ) + 0,
      fields: [
        { key: "product_name", label: "Product" },
        { key: "qty", label: "Quantity" },
        { key: "price", label: "Price" },
        { key: "total", label: "Total" },
      ],
    };
  },
  validations: {
    orderForm: {
      order_number: {},
      user_code: {},
      date_order: {},
      payment_method: {},
      delivery_address: {},
      notes: {},
      status: {},
    },
    confirmationPaymentForm: {
      order_number: {},
      user_code: {},
      account_no: {},
      account_name: {},
      payment_date: {},
      picture: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (id) {
      this.getDropdown();
      this.getConfirmation(id);
      this.unixTime = Math.floor(Math.random() * (0 - 9999999999 + 1) ) + 0;
    },
    back: function () {
      this.$router.go(-1);
    },
    preview: function () {
      this.previewModal = true;
    },
    cancelForm: function () {
      this.previewModal = false;
    },
    updateStatus: function () {
      if (confirm("Apakah anda ingin merubah Status ?")) {
        this.loadingStatus = true;
        this.axios
          .put(
            "console/confirmation_payment/update_status_order",
            this.orderForm
          )
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah Status",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Status");
          })
          .finally(() => {
            this.loadingStatus = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    getConfirmation: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/confirmation_payment/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.confirmationPaymentForm = response.data.data;
            this.getDataOrderDetail(this.confirmationPaymentForm.id_order);
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getDataOrderDetail(id) {
      this.loadingTab = true;
      this.axios
        .get("/console/order/listing_order_detail/" + id)
        .then((response) => {
          this.orderDetailData = response.data.data;
          this.orderForm.id = id;
          this.orderForm.order_number = response.data.order.order_number;
          this.orderForm.user_code = response.data.order.user_code;
          this.orderForm.status = response.data.order.status;
          this.loadingTab = false;
        });
    },
    getDropdown: function () {
      this.axios
        .get("/console/confirmation_payment/dropdown")
        .then((response) => {
          this.statusList = response.data.order_status;
        });
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.axios
          .put("console/notification/update", this.confirmationPaymentForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah Notification",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Notification");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
</style>